import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserInfo } from 'src/app/core/model/dataModels/userInfo';
import { APIServices } from 'src/app/core/config/app-config';
import { HttpDataService } from 'src/app/core/services/http.service'
import { MenuRoles } from '../model/dataModels/menuData';

@Injectable({ providedIn: 'root' })

export class LoginService 
{
  constructor(private httpService: HttpDataService) {}

  logout(): Observable<any> 
  {
    return this.httpService.Get<any>(APIServices.security.logout);
  }

  MenusWithRoles(): Observable<MenuRoles[]> 
  {
    return this.httpService.GetList<MenuRoles>(APIServices.roles_menus);
  }

  getUserADFS(): Observable<UserInfo>
  {
    return this.httpService.Get<UserInfo>(APIServices.security.UserADFS);
  }
}